// @flow

import { type Receipt, type InstalmentsPlan } from '../types';

export function getInstalmentsPlan(receipt: Receipt): ?InstalmentsPlan {
  return receipt['instalments_plan'];
}

export function getSafeInstalmentsPlan(receipt: Receipt): InstalmentsPlan {
  const instalmentsPlan = receipt['instalments_plan'];
  if (!instalmentsPlan)
    throw new Error('getSafeInstalmentsPlan: there is not instalments plan');
  return instalmentsPlan;
}
